/**
 * @generated SignedSource<<d1b0a166a67eef4e492486be848ce276>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DesktopLaunchPageQuery$variables = {
  platform: string;
};
export type DesktopLaunchPageQuery$data = {
  readonly latestVersion: {
    readonly downloadFile: string;
  } | null;
};
export type DesktopLaunchPageQuery = {
  response: DesktopLaunchPageQuery$data;
  variables: DesktopLaunchPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "platform"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "platform",
    "variableName": "platform"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadFile",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DesktopLaunchPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VersionNode",
        "kind": "LinkedField",
        "name": "latestVersion",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DesktopLaunchPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VersionNode",
        "kind": "LinkedField",
        "name": "latestVersion",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dfdd3378c5d086fd9829a772971f64ab",
    "id": null,
    "metadata": {},
    "name": "DesktopLaunchPageQuery",
    "operationKind": "query",
    "text": "query DesktopLaunchPageQuery(\n  $platform: String!\n) {\n  latestVersion(platform: $platform) {\n    downloadFile\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cde57839e8110d3bf2ccbe9d8dce8df";

export default node;
